import axios from "axios";
import { getToken } from "./Common.jsx";
const token = getToken();
const AUTH_TOKEN = "Bearer " + token;
axios.defaults.baseURL = "https://purchasing.primahotelindonesia.info/";
axios.defaults.headers.common["Authorization"] = AUTH_TOKEN;
axios.defaults.headers.post["Content-Type"] ="application/x-www-form-urlencoded,application/json";
export default axios;
